import { render } from "./DocImage.vue?vue&type=template&id=134711fc&ts=true"
import script from "./DocImage.vue?vue&type=script&lang=ts"
export * from "./DocImage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__